import { TipAkcizneKategorije } from './../../../../../../data-api/src/lib/eKompanija-api';
import { Component, DebugElement, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IEOtpremnicaDto, IStavkaOtpremniceDto, StavkaOtpremnice, StavkaOtpremniceDto, TipPredmeta } from '@kodit/core/data-api';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { Subscription } from 'rxjs';
import { EotpremnicaFormService } from '../../otpremnice/eotpremnica-form.service';
import { StavkaEoptremniceFormService } from '../../form-definitions/stavka-eotpremnice-form.service';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { PredmetStavkeResult } from '../rezultat-pretrage-stavke/rezultat-pretrage-stavke.component';

@Component({
  selector: 'kodit-stavke-eotpremnice-table',
  templateUrl: './stavke-eotpremnice-table.component.html',
  styleUrls: ['./stavke-eotpremnice-table.component.scss']
})
export class StavkeEotpremniceTableComponent implements OnInit, OnDestroy  {

  private _subs: Subscription = new Subscription();

  selectedStavke: StavkaOtpremniceDto[] = [];
  brojPocetnihStavki = 0;
  redniBrojZaRezultate: number = 0;
  stavkeOtpremnice: FormArray;
  rezultatiSearchValue: string;
  shouldDisplayRezultate: boolean;
  shouldDisableMagacinDropdown: boolean;
  disabledStavka: boolean = false;
  prethodniMagacinId: any = null;

  tipPredmetaRoba: TipPredmeta = TipPredmeta.ROBA;
  tipDuvan: TipAkcizneKategorije = TipAkcizneKategorije.DUVAN;
  tipNikotin: TipAkcizneKategorije = TipAkcizneKategorije.NIKOTINSKI_PROIZVODI;

  /** I/O */
  @Input() otpremnicaForm: FormGroupTypeSafe<IEOtpremnicaDto>;
  @Input() excludeTipovePredmeta: TipPredmeta[] = [];
  @Output() magacinRequired = new EventEmitter<void>();

  constructor(
    private _route: ActivatedRoute,
    private _formService: EotpremnicaFormService,
    private _stavkaForm: StavkaEoptremniceFormService,
  ) { }

  ngOnInit(): void {
    this.stavkeOtpremnice = this._formService.getStavkeArray;

    if(this.stavkeOtpremnice.length == 0)
    {
      this.brojPocetnihStavki = this.stavkeOtpremnice.value.length;
      this.addEmptyStavka();
    }

    if(this._formService.getOtpremnicaFormObject.controls.adresaOtpremeDto.value.magacinId === null)
    {
      this.disabledStavka = true;
    }
    this.prethodniMagacinId = this._formService.getOtpremnicaFormObject?.get('adresaOtpremeDto.magacinId').value;

    this._formService.getOtpremnicaFormObject?.get('adresaOtpremeDto.magacinId')?.valueChanges.subscribe(magacinId => {

      if (magacinId === this.prethodniMagacinId) {
        return;
      }

      this.prethodniMagacinId = magacinId;

      if (magacinId == null) {
        this.disabledStavka = true;
      } else {
        this.disabledStavka = false;
        this.stavkeOtpremnice.clear();
        this.brojPocetnihStavki = this.stavkeOtpremnice.value.length;
        this.addEmptyStavka();
      }
    });

    this.stavkeOtpremnice.controls.forEach((stavka, index) => {
      const tip = stavka
        .get('akciznaKategorijaDto.tipAkcizneKategorije')
        ?.value;

      this.onTipAkcizneKategorijeChange(tip, index);
    });

  }

  onArtikalInputClick(): void {
    if (this.disabledStavka) {
      this.magacinRequired.emit();
    }
  }

  updateRezultate(changedNaziv: string, stavkaIndex: number) {
    if (!changedNaziv || changedNaziv === '') {
      if (this.stavkeOtpremnice.value[stavkaIndex]?.predmetStavkeDto?.id > 0) {
        this.deleteStavka(stavkaIndex);
        this.addEmptyStavka();
        this.redniBrojZaRezultate = 0;
        this.shouldDisplayRezultate = false;
      }
    } else {
      this.redniBrojZaRezultate = stavkaIndex;
      this.rezultatiSearchValue = changedNaziv;
      this.shouldDisplayRezultate = true;
    }
  }

  deleteStavka(rowIndex: number): void {

    this.stavkeOtpremnice.removeAt(rowIndex);

    // update neto tezina na racun service ??? da li treba za otpremnice?
    //this._racunService.updateUkupnaNetoTezinaForStavke();

    if (this.stavkeOtpremnice.value?.length > 0) {
      this._formService.setAddedPredmetiStavki = this.stavkeOtpremnice.value.map(
        (x: IStavkaOtpremniceDto) => x.predmetStavkeDto?.id
      );
    } else {
      this._formService.setAddedPredmetiStavki = [];
    }
    this._updateRedneBrojeve();
  }

  private _updateRedneBrojeve() {
    this.stavkeOtpremnice.value.forEach((s: StavkaOtpremniceDto, i: number) => {
      this.stavkeOtpremnice
        .at(i)
        .get('redniBroj')
        .patchValue(i + 1);
    });
  }

  addEmptyStavka(): void {
    if (this.disabledStavka) {
      this.magacinRequired.emit();
      return;
    }
    for (let s of this.stavkeOtpremnice.controls) {
      if (s.value.predmetStavkeDto.id === 0) {
        return;
      }
    }
    const idx = this.stavkeOtpremnice.length;
    this.stavkeOtpremnice.push(
      this._stavkaForm.getFormGroup({
        redniBroj: idx + 1,
      })
    );
  }

  handleAddPredmetStavke(data: PredmetStavkeResult) {
    if (data == null || data.predmetStavke == null) {
      this.resetRezultati();
      return;
    }

    this._formService.patchPredmetStavke(
      data.predmetStavke,
      this.redniBrojZaRezultate,
      data.amount
    );

    this.resetRezultati();
  }

  resetRezultati() {
    this.redniBrojZaRezultate = -1;
    this.shouldDisplayRezultate = false;
  }

  onTipAkcizneKategorijeChange(event: TipAkcizneKategorije, rowIndex: number): void {
      const row = this.stavkeOtpremnice.at(rowIndex);

      if (!row) {
        return;
      }

      const akciza = row.get('akciznaKategorijaDto') as FormGroup;

      const vrednostCtrl = akciza.get('vrednost');
      const sifraCtrl = akciza.get('sifraRobneMarke');

      vrednostCtrl?.clearValidators();
      sifraCtrl?.clearValidators();

      if (event === null) {
        akciza.patchValue({
          tipAkcizneKategorije: null,
          vrednost: null,
          sifraRobneMarke: null
        });
        akciza.removeControl('tipPakovanjaDuvana');

        vrednostCtrl?.updateValueAndValidity();
        sifraCtrl?.updateValueAndValidity();
        return;
      }

      if (event === TipAkcizneKategorije.DUVAN) {
        sifraCtrl?.setValidators([Validators.required]);
        vrednostCtrl?.setValue(null);
      }
      else {
        vrednostCtrl?.setValidators([
          Validators.required
        ]);

        sifraCtrl?.setValue(null);
        akciza.removeControl('tipPakovanjaDuvana');
      }

      vrednostCtrl?.updateValueAndValidity();
      sifraCtrl?.updateValueAndValidity();

  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }

}
